import { FC, ReactNode } from "react";
import "@rmwc/tooltip/styles";
import { Badge as MdBadge, BadgeAnchor } from "@rmwc/badge";
import "@rmwc/badge/styles";

export type BadgesTypes = {
  align?: "end" | "start" | "inline";
  inset?: undefined | string;
  label: ReactNode | number;
  exited?: boolean;
  backgroundColor?: string;
  color?: string;
};

const Badges: FC<BadgesTypes> = ({ align, backgroundColor, color, inset, label, exited, children }) => {
  return (
    <BadgeAnchor className="notification-badge">
      <MdBadge align={align} label={label} exited={exited} inset={inset} style={{ backgroundColor, color }} />
      {children}
    </BadgeAnchor>
  );
};

export default Badges;
